var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2507 29.7498C16.2174 28.5831 15.5674 25.3665 14.0674 23.3331C12.584 21.2498 10.534 19.8165 8.46737 18.4331C6.99249 17.5041 5.67584 16.345 4.56737 14.9998C4.1007 14.4498 3.1507 13.4331 4.11737 13.2331C5.1007 13.0331 6.8007 13.9998 7.66737 14.3665C9.18403 14.9998 10.684 15.7331 12.084 16.5998L13.7674 13.7665C11.1674 12.0498 7.83403 10.5331 4.73403 10.0831C2.96737 9.81648 1.1007 10.1831 0.500698 12.0998C-0.0326351 13.7498 0.817365 15.4165 1.78403 16.7165C4.06737 19.7665 7.61737 21.2331 10.2674 23.8665C10.834 24.4165 11.5174 25.0665 11.8507 25.8331C12.2007 26.5665 12.1174 26.6165 11.334 26.6165C9.26737 26.6165 6.68403 24.9998 5.0007 23.9331L3.31737 26.7665C5.86737 28.3331 10.134 30.7831 13.2507 29.7498ZM31.734 3.74981C32.1007 3.38315 32.1007 2.78315 31.734 2.43315L29.5674 0.266479C29.3932 0.0974618 29.1601 0.00292969 28.9174 0.00292969C28.6747 0.00292969 28.4415 0.0974618 28.2674 0.266479L26.5674 1.96648L30.034 5.43315M15.334 13.1998V16.6665H18.8007L29.0507 6.41648L25.584 2.94981L15.334 13.1998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignDocument);
export default __webpack_public_path__ + "static/media/sign-document.6074ba091e0c08a8b130038307dda6e4.svg";
export { ForwardRef as ReactComponent };